/* globals localStorage */
import {API} from 'src/api'

export default {
  login (email, password, cb) {
    cb = arguments[arguments.length - 1]
    if (localStorage.token) {
      // eslint-disable-next-line
      if (cb) cb(true)
      this.onChange(true)
      return
    }
    loginRequest(email, password, (res) => {
      if (res.authenticated) {
        localStorage.token = res.token
        var token = JSON.parse(atob(localStorage.token))
        // eslint-disable-next-line
        for (let info of Object.values(token)) {
          localStorage.userInfo = JSON.stringify(token.claims.restaurant)
        }
        // eslint-disable-next-line
        if (cb) cb(true)
        this.onChange(true)
      } else {
        // eslint-disable-next-line
        if (cb) cb(false)
        this.onChange(false)
      }
    })
  },

  getToken () {
    return localStorage.token
  },

  logout () {
    delete localStorage.token
    delete localStorage.userInfo
    this.onChange(false)
  },

  loggedIn () {
    return !!localStorage.token
  },

  onChange () {}
}

function loginRequest (email, password, cb) {
  if (email && password) {
    // alert(email + ' / ' + password)
    API.post('/connect/token/', {
      email: email,
      password: password,
      api_source: 'restaurant'
    })
    .then(function (response) {
      // console.log(JSON.stringify(response, null, '  '))
      if (response.data.access_token) {
        // eslint-disable-next-line
        cb({
          authenticated: true,
          token: response.data.access_token
        })
      } else {
        // eslint-disable-next-line
        cb({
          authenticated: false
        })
      }
    })
    .catch(function (error) {
      // eslint-disable-next-line
      cb({
        authenticated: false
      })
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/auth.js